import { FunctionComponent, useEffect, useState } from "react"
import React from "react"
import { Col, Row, Space, Spin, Switch } from "antd"
import { Position } from "../components/position"
import { PositionsService } from "../api/services.gen"
import { PositionDto } from "../api"

interface PositionsPageProps {
}

const PositionsPage: FunctionComponent<PositionsPageProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [useLastSale, setUseLastSale] = useState<boolean>(true)

  const [positions, setPositions] = useState<PositionDto[]>([])
  const fetchPositions = async () => {
    setLoading(true)
    try {
      const positions = await PositionsService.getCurrentPositions()
      setPositions(positions.positions)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPositions()
  }, [])

  if (loading) {
    return <>
      <h2>Positions</h2>
      <Space>
        <Spin />
      </Space>
    </>
  }
  
  return <>
    <h2>Positions</h2>
    <Switch checkedChildren="Use orderbook" unCheckedChildren="Use last sale" checked={useLastSale} onChange={setUseLastSale} />
    <Row gutter={[16, 16]}>
      {
        positions.length === 0 ? <p>No positions</p> : null
      }
      {
        positions?.map(position => <Col><Position position={position} useLastSale={useLastSale} {...props} /></Col>)
      }
    </Row>
  </>
}

export { PositionsPage }